export default __webpack_public_path__ + "static/guitar-player-2-3d8903842be6203114812bfe3462d7cc.gif";